exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo[data-v-61d4af7e]{margin-top:0;color:#fff;font-size:13px}.buttons[data-v-61d4af7e]{display:flex;justify-content:center;align-items:center}.msg[data-v-61d4af7e]{color:#708090;font-size:13px;margin-bottom:10px}p[data-v-61d4af7e]{font-size:14px;margin-bottom:10px;color:#2f4f4f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61d4af7e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ItemCheckIn.vue
// module id = 172
// module chunks = 0